<div class="component">
  <div *ngFor="let tabelMethode of tabelModel">
    <app-table *ngIf="tabelMethode" [model]="tabelMethode">
    </app-table>
  </div>
</div>
